const isInternalPage = (availability) =>
  !!availability && availability.toLowerCase().includes('internal')

export const getPostingUuid = (posting = {}, availability, landedUuid) => {
  if (landedUuid) return landedUuid
  return isInternalPage(availability) ? posting.intUuid : posting.extUuid
}

export const getPostingIdentifier = (posting = {}, availability, landedUuid) =>
  getPostingUuid(posting, availability, landedUuid) || posting.jobId
